import { useNavigate } from "react-router-dom";
import { useProgressStore } from "../../stores/progressStore";
import { lessonPath } from "../../routes";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  hidden?: boolean;
}

export function ProgressBar({ hidden = false }: ProgressBarProps) {
  const navigate = useNavigate();

  const activeCourse = useProgressStore((s) => s.activeCourse);
  const currentUnit = useProgressStore(
    (s) => s.courses[s.activeCourse].currentUnit,
  );
  const currentLesson = useProgressStore(
    (s) => s.courses[s.activeCourse].currentLesson,
  );
  const numLessons = useProgressStore((s) =>
    s.getNumLessons(s.activeCourse, s.courses[s.activeCourse].currentUnit),
  );
  const getLessonStatus = useProgressStore((s) => s.getLessonStatus);

  return (
    <footer
      className={[styles.bar, hidden ? styles.hidden : ""]
        .filter(Boolean)
        .join(" ")}
    >
      {Array.from({ length: numLessons }, (_, index) => {
        const lesson = index + 1;
        const status = getLessonStatus(activeCourse, currentUnit, lesson);
        const isCurrent = currentLesson === lesson;
        const className = [
          styles.box,
          isCurrent ? styles.current : "",
          status === "finished" ? styles.finished : "",
          status === "started" && !isCurrent ? styles.started : "",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <button
            key={lesson}
            type="button"
            className={className}
            title={"Lesson: " + lesson}
            onClick={() =>
              navigate(lessonPath(activeCourse, currentUnit, lesson))
            }
          >
            {lesson}
          </button>
        );
      })}
    </footer>
  );
}
